import React from 'react';

// Dark title band shown at the top of every inner page.
const PageHeader = ({ eyebrow, title, children }) => (
  <header className="page-header">
    <div className="page">
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h1>{title}</h1>
      {children && <p>{children}</p>}
    </div>
  </header>
);

export default PageHeader;
